module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-product-3-b0f6484aac5e212444546ac60f3fc973.jpg";